import { View, Pressable } from "react-native";
import React, { useEffect, useState } from "react";
import { Entypo } from "@expo/vector-icons";
import { EventGroupNoticeDetails } from "features/types";
import classNames from "classnames";
import { Text } from "@ui-kitten/components";
import { LIGHT_BLUE } from "constants/";

interface Props {
  eventGroupNotices: EventGroupNoticeDetails[];
}
const EventNotices = ({ eventGroupNotices }: Props) => {
  const [visible, setVisible] = useState(false);

  const eligibleNotices = eventGroupNotices
    .filter((notice) => notice.displayTypes.includes("SEAT_SELECTION"))
    .filter((notice) => notice.enabled);

  useEffect(() => {
    if (eligibleNotices.length > 0) {
      setVisible(true);
    }
  }, []);

  return (
    <View
      className={classNames("fixed top-0 left-0 right-0 z-10 bg-white", {
        hidden: !visible,
      })}
    >
      <View className="p-4 flex-row items-center justify-between gap-4">
        <Entypo name="info-with-circle" size={16} color={LIGHT_BLUE} />
        <View className="flex-1">
          {eligibleNotices.map((notice, index) => (
            <Text key={index} style={{ overflow: "hidden" }} category="s1">
              {notice.description}
            </Text>
          ))}
        </View>
        <Pressable onPress={() => setVisible(false)}>
          <Entypo name="cross" size={24} />
        </Pressable>
      </View>
    </View>
  );
};

export default EventNotices;
